import { render, staticRenderFns } from "./AutoCompleteInput.vue?vue&type=template&id=70bf8034"
import script from "./AutoCompleteInput.vue?vue&type=script&lang=js"
export * from "./AutoCompleteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports